import { Svg, FilledPath, EmptyPath } from './styles'

export function Hexagon({ icon }) {
  return (
    <Svg viewBox="0 0 259 259" xmlns="http://www.w3.org/2000/svg">
      <FilledPath
        d="M91 0L169.808 45.5V136.5L91 182L12.1917 136.5V45.5L91 0Z"
        className="filled"
      />
      {icon}
      <EmptyPath d="M91.1917 105.655L168 61.3094L244.808 105.655V194.345L168 238.691L91.1917 194.345V105.655Z" />
    </Svg>
  )
}
